import Hub from 'base/hub'

// When a `FIRE_EVENT` action is dispatched, we send it on over to `Hub`
const eventsMiddleware = () => next => action => {
  if (action.meta && action.meta.analytics) {
    const { event, properties } = action.meta.analytics.eventPayload
    Hub.pub(event, properties)
  }

  next(action)
}

export default eventsMiddleware
